import React from 'react';

function PrivacyPolicy() {
  return (
    <div style={{
      maxWidth: '900px',
      margin: '0 auto',
      padding: '40px 20px',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
      lineHeight: '1.6',
      color: '#333'
    }}>
      <header style={{
        borderBottom: '3px solid #3b82f6',
        paddingBottom: '20px',
        marginBottom: '30px'
      }}>
        <h1 style={{
          fontSize: '32px',
          fontWeight: '700',
          color: '#1f2937',
          margin: '0 0 10px 0'
        }}>
          Privacy Policy
        </h1>
        <p style={{
          fontSize: '16px',
          color: '#6b7280',
          margin: '0'
        }}>
          Remote Inspection App
        </p>
      </header>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{
          fontSize: '24px',
          fontWeight: '600',
          color: '#1f2937',
          marginBottom: '15px'
        }}>
          Introduction
        </h2>
        <p style={{ marginBottom: '15px' }}>
          The Remote Inspection App is committed to protecting your privacy and handling your 
          personal information with care and respect. This Privacy Policy describes how we collect, 
          use, store, and protect your information when you use our platform for remote property inspections.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{
          fontSize: '24px',
          fontWeight: '600',
          color: '#1f2937',
          marginBottom: '15px'
        }}>
          Information We Collect
        </h2>
        <p style={{ marginBottom: '10px' }}>
          We collect the following types of information:
        </p>
        <ul style={{
          paddingLeft: '20px',
          marginBottom: '15px'
        }}>
          <li style={{ marginBottom: '8px' }}>
            <strong>Account Information:</strong> Name, email address, phone number, and authentication credentials for appraisers
          </li>
          <li style={{ marginBottom: '8px' }}>
            <strong>Session Information:</strong> Inspection session codes, timestamps, and session metadata
          </li>
          <li style={{ marginBottom: '8px' }}>
            <strong>Communication Data:</strong> Phone numbers provided for SMS notifications and inspection access
          </li>
          <li style={{ marginBottom: '8px' }}>
            <strong>Media Files:</strong> Photos and videos captured during remote property inspections
          </li>
          <li style={{ marginBottom: '8px' }}>
            <strong>Technical Information:</strong> Device information, IP addresses, and usage data necessary for service operation
          </li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{
          fontSize: '24px',
          fontWeight: '600',
          color: '#1f2937',
          marginBottom: '15px'
        }}>
          How We Use Your Information
        </h2>
        <p style={{ marginBottom: '10px' }}>
          We use your information to:
        </p>
        <ul style={{
          paddingLeft: '20px',
          marginBottom: '15px'
        }}>
          <li style={{ marginBottom: '8px' }}>Facilitate remote property inspection sessions between appraisers and homeowners</li>
          <li style={{ marginBottom: '8px' }}>Send session access codes and appointment notifications via SMS</li>
          <li style={{ marginBottom: '8px' }}>Store and manage inspection photos and videos securely</li>
          <li style={{ marginBottom: '8px' }}>Authenticate users and maintain account security</li>
          <li style={{ marginBottom: '8px' }}>Improve our services and troubleshoot technical issues</li>
          <li style={{ marginBottom: '8px' }}>Comply with legal obligations and industry regulations</li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{
          fontSize: '24px',
          fontWeight: '600',
          color: '#1f2937',
          marginBottom: '15px'
        }}>
          Data Storage and Security
        </h2>
        <p style={{ marginBottom: '15px' }}>
          We implement industry-standard security measures to protect your information:
        </p>
        <ul style={{
          paddingLeft: '20px',
          marginBottom: '15px'
        }}>
          <li style={{ marginBottom: '8px' }}>
            <strong>Secure Storage:</strong> Inspection photos and videos are stored securely in encrypted cloud storage
          </li>
          <li style={{ marginBottom: '8px' }}>
            <strong>Access Controls:</strong> Only authorized appraisers can access their session data
          </li>
          <li style={{ marginBottom: '8px' }}>
            <strong>Encryption:</strong> All data transmissions are encrypted using industry-standard protocols (HTTPS/TLS)
          </li>
          <li style={{ marginBottom: '8px' }}>
            <strong>Password Protection:</strong> User passwords are securely hashed and never stored in plain text
          </li>
          <li style={{ marginBottom: '8px' }}>
            <strong>Session Security:</strong> Access codes are time-limited and expire after use
          </li>
        </ul>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{
          fontSize: '24px',
          fontWeight: '600',
          color: '#1f2937',
          marginBottom: '15px'
        }}>
          Data Sharing and Third Parties
        </h2>
        <p style={{ marginBottom: '15px' }}>
          We do not sell, rent, or trade your personal information. We may share data with trusted 
          service providers who help us operate the platform, including:
        </p>
        <ul style={{
          paddingLeft: '20px',
          marginBottom: '15px'
        }}>
          <li style={{ marginBottom: '8px' }}>
            <strong>Communication Services:</strong> For delivering SMS messages and notifications
          </li>
          <li style={{ marginBottom: '8px' }}>
            <strong>Cloud Storage and Hosting Providers:</strong> For secure data storage and application infrastructure
          </li>
          <li style={{ marginBottom: '8px' }}>
            <strong>Content Delivery Services:</strong> For efficient media file delivery and management
          </li>
        </ul>
        <p style={{ marginBottom: '15px' }}>
          These service providers are contractually obligated to protect your information and use it 
          only for the purposes we specify. We may also disclose information when required by law or 
          to protect our rights and safety.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{
          fontSize: '24px',
          fontWeight: '600',
          color: '#1f2937',
          marginBottom: '15px'
        }}>
          Data Retention
        </h2>
        <p style={{ marginBottom: '15px' }}>
          We retain your information for as long as necessary to provide our services and comply with 
          legal obligations. Inspection photos and videos are stored for the duration determined by 
          the appraiser's retention requirements. Session access codes expire within 24 hours of creation.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{
          fontSize: '24px',
          fontWeight: '600',
          color: '#1f2937',
          marginBottom: '15px'
        }}>
          Your Rights and Choices
        </h2>
        <p style={{ marginBottom: '10px' }}>
          You have the following rights regarding your personal information:
        </p>
        <ul style={{
          paddingLeft: '20px',
          marginBottom: '15px'
        }}>
          <li style={{ marginBottom: '8px' }}>
            <strong>Access:</strong> Request access to your personal information we hold
          </li>
          <li style={{ marginBottom: '8px' }}>
            <strong>Correction:</strong> Request correction of inaccurate information
          </li>
          <li style={{ marginBottom: '8px' }}>
            <strong>Deletion:</strong> Request deletion of your information, subject to legal retention requirements
          </li>
          <li style={{ marginBottom: '8px' }}>
            <strong>Opt-Out:</strong> Reply STOP to any SMS message to opt out of future text communications
          </li>
        </ul>
        <p style={{ marginBottom: '15px' }}>
          To exercise these rights or for questions about your data, please contact your real estate 
          appraiser or our support team.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{
          fontSize: '24px',
          fontWeight: '600',
          color: '#1f2937',
          marginBottom: '15px'
        }}>
          Changes to This Privacy Policy
        </h2>
        <p style={{ marginBottom: '15px' }}>
          We may update this Privacy Policy from time to time to reflect changes in our practices or 
          legal requirements. We will notify you of any material changes by posting the updated policy 
          on this page with a new "Last Updated" date.
        </p>
      </section>

      <section style={{ marginBottom: '30px' }}>
        <h2 style={{
          fontSize: '24px',
          fontWeight: '600',
          color: '#1f2937',
          marginBottom: '15px'
        }}>
          Contact Us
        </h2>
        <p style={{ marginBottom: '15px' }}>
          If you have questions or concerns about this Privacy Policy or our data practices, please contact:
        </p>
        <p style={{ marginBottom: '15px' }}>
          Remote Inspection App Support Team<br />
          Via your real estate appraiser or service provider
        </p>
      </section>

      <footer style={{
        borderTop: '2px solid #e5e7eb',
        paddingTop: '20px',
        marginTop: '40px',
        fontSize: '14px',
        color: '#6b7280'
      }}>
        <p style={{ margin: '0 0 10px 0' }}>
          <strong>Last Updated:</strong> December 2025
        </p>
        <p style={{ margin: '0' }}>
          By using the Remote Inspection App, you acknowledge that you have read and 
          understood this Privacy Policy.
        </p>
      </footer>
    </div>
  );
}

export default PrivacyPolicy;


